module.exports = __webpack_public_path__ + "img/orders-on.7125a4b3.svg";